import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Button from "../../../components/Button/Button";
import { Table } from "../../../components/Table/Table";
import { useGetListReturnOnSale } from "../../../hooks/useAccounting";
import { Container } from "../../../theme/GlobalStyle";
import { MiladiToShamsi } from "../../../utils/Miladi_To_Shamsi";
import { separate } from "../../../utils/separate";

const ListReturnOnSale = () => {
  const navigate = useNavigate();

  const headerTitle = [
    "ردیف",
    "شماره فاکتور",
    "تاریخ",
    "خریدار",
    "مبلغ",
    "توسط",
    "ویرایش",
  ];

  const { data: listReturnOnSale } = useGetListReturnOnSale();
  const return_on_sales = listReturnOnSale?.data?.return_on_sales;
  const UserSubmitted = listReturnOnSale?.data?.UserSubmitted;

  const items = return_on_sales?.map((item, index) => (
    <tr key={item.IdProducts}>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {index + 1}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {item.FactorTag}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {MiladiToShamsi(item.created_at)}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {`${item?.FirstName} ${item.LastName}`}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {separate(item?.PriceAll ? item?.PriceAll : "")}
        </span>
      </td>

      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {UserSubmitted[index]}
        </span>
      </td>
      <td>
        <Button
          small="100px"
          bgColor="#0D6EFD"
          size="12px"
          color="#fff"
          onclick={() => {
            navigate(
              `/dashboard/accounting/orders/return-sales?IdEquivalentReturnOnSales=${item?.IdEquivalentReturnOnSales}`
            );
          }}
        >
          ویرایش
        </Button>
      </td>
    </tr>
  ));

  return (
    <Fragment>
      <BreadCrumb
        margin="mt-3"
        num1="واحد حسابداری"
        num2="عملیات"
        num3="لیست برگشت از فروش"
      />
      <Container>
        <Table
          headerTitle={headerTitle}
          items={items}
          //   content={
          //     <Contetn
          //       IdEquivalentOrderOffline={id ? id : IdEquivalentOrderOffline}
          //       setForm={setForm}
          //     />
          //   }
        />
      </Container>
    </Fragment>
  );
};

export default ListReturnOnSale;
